import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { TaskService } from 'src/app/services/task.service';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from '../../alert/alert.component';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { environment } from 'src/environments/environment';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { Enums } from 'src/app/helpers/enums';

@Component({
  selector: 'app-activated-process-task',
  templateUrl: './activated-process-task.component.html',
  styleUrls: ['./activated-process-task.component.css']
})
export class ActivatedProcessTaskComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElement1: DataTableDirective;
  dtOptions1: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger1: Subject<any> = new Subject();

  public downloadLink: string;

  uploadProofactivatedTaskForm: FormGroup;

  processId: string;
  taskStatusTypes: any[];
  forkJoinStream: any;
  companytasklist: any[];
  groupTypes: any[];
  groupID: any;
  processID: any;
  taskStatusID: any;
  activatedTasklist: any;
  CompletedDateModel: any;
  processes: any[];
  processType: string;
  SearchprocessUserdefinedorPredefinedModel: any;

  selectedAll: any;
  IsSelectedTasks: any;
  taskid:any;
  docid:any;
  fileUpload: any;
  filesToUpload: Array<File>;
  orignalName: any;
  fileName: any;
  fileuploadstatus: any;
  TaskStatusModel: any;
  IsSelectedUpload: any;
  originalfileName: string;
  todaysDate: any;

  selectedNewDocumentCompanytasks = [];
  selectedUpdatedDocumentCompanytasks = [];
  PageTitle: any;
  searcheFilteredDataTask: any[];
  tokenForFile :any  = localStorage.getItem('token')
  fileExtension: boolean = true;
  typeHasError: boolean = true;
  FileOrignalName: any;
  changedName: any;
  titleOnAddUpdate: any;
  pdfArray1 = [];
  taskProofData = [];
  documentIdToDelete = '';
  pdfToDelete = '';
  taskId: any;
  isLoading: boolean = false;

  constructor(private taskService: TaskService, 
    private documentManagementMasterService: DocumentManagementMasterService,
    private processService: ProcessMasterService, 
    private groupMasterService: GroupMasterService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private commonFunction: CommonFunction, 
    private alert: AlertComponent, 
    private documentManagementService: DocumentManagementMasterService,
    private meetingService: MeetingMasterService,
    private location: Location,
    private route: ActivatedRoute,
    private authAlert: AuthAlertComponent) {
    // this.taskStatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    var taskstatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    this.taskStatusTypes = $(taskstatusTypes).filter(function (i, n) { return (n.id != "3") });
  }



  ngOnInit() {

    this.environmentSettings = environment;
    this.downloadLink = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/'
    this.commonFunction.validateURL('ActivatedProcessTasks', '');

    this.initialiseJqueryEvents();


    this.IsSelectedUpload = false;


    this.activatedRoute.params.subscribe(params => {
      console.log(JSON.parse(localStorage.getItem("companyDetails")).companyID);
      if (params['processId'] != undefined) {

        var data = {
          module: 'ActivatedProcess',
          ID: params['processId'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        this.processId = params['processId'];
        this.meetingService.authonticateDataForComapnay(data).subscribe(processAccess => {
          console.log(processAccess)
          if (processAccess.status == 0) {
            this.getProcessActivatedTaskList(params['processId']);
          } else {
            console.log('in else')
            this.authAlert.validateModuleWithPermissions('ActivatedProcess', params['processId'], processAccess.companyID, 'edit')
          }
        })
      }
    })

    this.dtOptions = {
      destroy: true,
      scrollY: "300px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [6, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0, 8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Activated Process Task List',
          title: 'Activated Process Task List',
          extend: 'excel',
          exportOptions: {
            columns: [2,3,4,5,8,11,12],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ],
      drawCallback: () => {
        // Reposition completion button after table draw
        setTimeout(() => {
          this.positionCompletionButton();
        }, 50);
      }


    };

    this.dtOptions1 = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    // var self = this;
    // setTimeout(function () {

    //   let table1 = $("#activatedprocesstaskTable").DataTable();
    //   var searchedDataForSelectAll = [];

    //   table1.on('search.dt', function () {
    //     self.searcheFilteredDataTask = [];
    //     var tableData = $("#activatedprocesstaskTable").DataTable().column(0, { search: 'applied' }).data();
    //     for (var i = 0; i < tableData.length; i++) {
    //       self.searcheFilteredDataTask.push(tableData[i])
    //     }

    //     var value = $('.dataTables_filter input').val();
    //     console.log("value,selectAll", value, self.selectedAll);

    //     if (value && self.selectedAll == true) {
    //       if (self.selectedAll == true) {
    //         self.selectedAll = false;

    //       }
    //       else {
    //         self.selectedAll = true;

    //       }
    //     }


    //   });
    // }, 3000);


    this.uploadProofactivatedTaskForm = new FormGroup({
      fileData: new FormControl('', []),
      TaskStatus: new FormControl('', []),
      CompletedDate: new FormControl('', [])
    });

    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');

    this.getTodaysDate();

  }

  EditTask(taskId) {
    localStorage.setItem('redirectfromActivatedProcess', this.processId);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'activated','update',taskId]  } }],
      { relativeTo: this.route.parent });
  }


  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
  }


  showStatusandUploadProofDialog() {
    this.IsSelectedUpload = false;
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.TaskStatus.updateValueAndValidity();
    this.uploadProofactivatedTaskForm.controls.CompletedDate.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.CompletedDate.updateValueAndValidity();

  }
  count: number = 0;
  checkselected(ev) {
    if (ev.target.checked == true) {
      this.count = this.count + 1;
      this.IsSelectedTasks = true;
    }
    else {
      this.count = this.count - 1;
      this.IsSelectedTasks = false;
    }

    var allSearchedSelected = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {
            if (this.companytasklist[i].SelectedTasks) {
            } else {
              allSearchedSelected = false;
            }
          }
        }
      }
    }
    if (allSearchedSelected) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }

  }

  checkIfAllSelected() {
    this.selectedAll = this.companytasklist.every(function (item: any) {
      return item.SelectedTask == true;

    })
  }

  selectAll() {
    if (this.searcheFilteredDataTask != undefined) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {

            this.companytasklist[i].SelectedTask = this.selectedAll;
            this.IsSelectedTasks = this.selectedAll;
          }
        }
      }

    }
    else {
      for (var i = 0; i < this.companytasklist.length; i++) {
        this.companytasklist[i].SelectedTask = this.selectedAll;
        this.IsSelectedTasks = this.selectedAll;
      }

    }

  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  positionCompletionButton() {
    setTimeout(() => {
      const dtButtons = $('#activatedprocesstaskTable').closest('.dataTables_wrapper').find('.dt-buttons');
      const completionBtn = $('.completionBtn');
      
      if (dtButtons.length && completionBtn.length) {
        // Move completion button next to DataTables buttons
        completionBtn.insertAfter(dtButtons);
      }
    }, 100);
  }

  onFileChange(event) {
    let reader = new FileReader();
    this.IsSelectedUpload = true;
    if (event.target.files && event.target.files.length > 0) {
      // this.filesToUpload = <Array<File>>event.target.files;

      var checkfile = this.commonFunction.checkFileExtension(event);
      if(checkfile){
      //  this.filesToUpload = event.target.files[0];
       this.filesToUpload = <Array<File>>event.target.files;
       this.fileExtension = true;
      }else{
       this.fileExtension = false;
      }
     console.log("fileExtension", this.fileExtension);

      this.IsSelectedUpload = true;
      let file = event.target.files[0];
      this.originalfileName = file.name;
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      const headers = new Headers();
      headers.append('Content-Type', 'multipart/form-data');
      this.fileUpload = formData
      reader.readAsDataURL(file);
      //console.log('event', event);
      reader.onload = () => {
        console.log('filename', file.name);
        console.log('filename', this.fileUpload);
      };
    }
  }

  uploadProofDocument() {

    if (this.filesToUpload == undefined && this.IsSelectedUpload === false) {

      for (let result of this.companytasklist) {
        if (result.SelectedTask === true) {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              DocumentName: result.TaskName,
              DateOfDocument: new Date(),
              Upload: this.orignalName,
              MeetingTypeID: null,
              ParentDocumentTypeID: null,
              ParentSubDocumentTypeID: null,
              DirectorKmp: "None",
              DirectorID: null,
              KMPID: null,
              Remarks: "",
              OriginalFileName: this.originalfileName,
              DocumentID: result.DocumentID,
              ActivatedTaskID: result.ID,
              //TaskStatus: this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              TaskStatus: (this.uploadProofactivatedTaskForm.controls.TaskStatus.value == '0') ? 1 : this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              CompletedDate: this.commonFunction.setDate(this.uploadProofactivatedTaskForm.controls.CompletedDate.value)
            }
          }

          this.selectedNewDocumentCompanytasks.push(newDocumentManagement);

        }

      }

      var SelectedDocumentTasks = {
        selectedDocumentTasks: this.selectedNewDocumentCompanytasks
      }



      this.taskService.updateTaskStatusforMultipleactivatedTasks(SelectedDocumentTasks)
        .subscribe(documentManagement => {
          if (documentManagement.status == 0) {
            //console.log("documentManagement" + documentManagement);
            $('#uploadProofDialog').modal('toggle');
            this.alert.success(documentManagement.message);
            this.getProcessActivatedTaskList(this.processId);
            //this.updateDocumentProofID(documentManagement.result._id);
          }
          else {
            $('#uploadProofDialog').modal('toggle');
            this.alert.error(documentManagement.message);
          }

        });
    }
    else {

      this.fileName = this.uploadProofactivatedTaskForm.controls.fileData.value;

      if (this.filesToUpload == undefined) {
        this.IsSelectedUpload = true;
        return false;
      }
      this.upload();

      // var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
      // var companyID = companyDetails.companyID;
      // this.companytasklist;
      for (let result of this.companytasklist) {
        if (result.SelectedTask === true) {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              DocumentName: result.TaskName,
              DateOfDocument: new Date(),
              Upload: this.orignalName,
              MeetingTypeID: null,
              ParentDocumentTypeID: null,
              ParentSubDocumentTypeID: null,
              DirectorKmp: "None",
              DirectorID: null,
              KMPID: null,
              Remarks: "",
              OriginalFileName: this.originalfileName,
              DocumentID: result.DocumentID,
              ActivatedTaskID: result.ID,
              //TaskStatus: this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              TaskStatus: (this.uploadProofactivatedTaskForm.controls.TaskStatus.value == '0') ? 1 : this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              CompletedDate: this.commonFunction.setDate(this.uploadProofactivatedTaskForm.controls.CompletedDate.value)
            }
          }

          this.selectedNewDocumentCompanytasks.push(newDocumentManagement);

        }

      }

      var SelectedDocumentTasks = {
        selectedDocumentTasks: this.selectedNewDocumentCompanytasks
      }

      this.documentManagementService.addMultipleDocuments(SelectedDocumentTasks)
        .subscribe((documentManagement:any) => {
          if (documentManagement.status == 0) {
            console.log("documentManagement" + documentManagement);
            $('#uploadProofDialog').modal('toggle');
            this.alert.success(documentManagement.message);
            this.getProcessActivatedTaskList(this.processId);
            //this.updateDocumentProofID(documentManagement.result._id);
          }
          else {
            $('#uploadProofDialog').modal('toggle');
            this.alert.error(documentManagement.message);
          }

        });

    }


  }

  upload() {
    var file = this.filesToUpload;
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      this.fileuploadstatus = result;
      console.log(this.fileuploadstatus)
    });
  }


  getSelectedProcessID(event) {
    var id = event.target.value;
    this.processID = id;
  }

  setid(taskid,id){

    console.log("id********",taskid,id);
    this.taskid = taskid;
    this.docid = id;

  }


  
  deleteProof() {
    
        var uploadedProof = {
          activatedTaskId: this.taskid,
          documentId: null
        }
        this.taskService.updateDocumentIdforActivatedTask(uploadedProof)
          .subscribe(updatedActivatedTask => {
            if (updatedActivatedTask.status == 0) {
    
              this.documentManagementMasterService.deleteDocumentManagement(this.docid).subscribe((data:any) => {
                if (data.status == 0) {
    
                  this.alert.success("Proof deleted successfully.");
                  $('#confirmation').modal('toggle');
                  this.ngOnInit();
                }
                else {
                  $('#confirmation').modal('toggle');
                  this.alert.error(data.message);
                }
              });
    
            }
            else {
              this.alert.error(updatedActivatedTask.message);
            }
          });
      }



  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList:any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }



  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        //this.agendaAddForm.controls.uploadFile.setValue(formData);
        this.orignalName = newDate + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }


  // getActivatedProcessTaskListBySerachFilters(searchParameters) {

  //   if (this.dtElement.dtInstance != undefined) {
  //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //       dtInstance.destroy();
  //     });
  //   }
  //   this.companytasklist = [];

  //   let usersList = this.taskService.getUsersList();
  //   let activatedTaskList = this.taskService.getActivatedProcessTaskListBySerachFilters(searchParameters);

  //   Observable.forkJoin([activatedTaskList, usersList])
  //     .subscribe((response) => {

  //       if (response[0].status == 0 && response[1].status == 0) {

  //         this.activatedTasklist = response;
  //         let activatedTaskData = response[0].processList;
  //         let usersData = response[1].result;

  //         var activatedtasksData = [];

  //         // AssignedTo , CreatedBy 
  //         _.forEach(activatedTaskData, function (activatedTask) {
  //           var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
  //           _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
  //           //_.assign(activatedTask, { SelectedTask: false })
  //           var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
  //           _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

  //           activatedtasksData.push(activatedTask);
  //         })

  //         this.companytasklist = activatedtasksData;
  //       }
  //       this.dtTrigger.next();
  //     });

  // }

  getTaskStatus(duedate, completeddate, taskStatus) {

    var text = "";
    var dueDate = (duedate != null || duedate != undefined) ? duedate : null;
    var completeddate = (completeddate != null || completeddate != undefined) ? completeddate : null;
    if (dueDate != null && completeddate != null) {
      if (completeddate > dueDate) {
        text = this.getStatusforTask(3);
      }
      else {
        text = this.getStatusforTask(taskStatus);
      }
    }
    else {
      text = this.getStatusforTask(taskStatus);
    }
    return text;
  }

  getStatusforTask(taskStatusId) {

    var taskStatusName = '';
    switch (taskStatusId) {
      case 1:
        taskStatusName = "Pending";
        break;
      case 2:
        taskStatusName = "Completed";
        break;
      case 3:
        taskStatusName = "Delayed Completion";
        break;
      case 4:
        taskStatusName = "Partially Completed";
        break;
      case 5:
        taskStatusName = "NA";
        break;
      case 6:
        taskStatusName = "Done";
        break;
      case 7:
        taskStatusName = "Cancelled";
        break;
      default:
        taskStatusName = "";
    }
    return taskStatusName;
  }


  getProcessActivatedTaskList(processId: string) {
    this.isLoading = true;
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();  // DESTROY previous table instance
      });
    }
  
    this.companytasklist = [];
  
    let usersList = this.taskService.getUsersList();
    let activatedTaskList = this.taskService.getActivatedProcessTaskListByProcessId(processId);
  
    Observable.forkJoin([activatedTaskList, usersList])
      .subscribe((response: any) => {
        console.log('response', response);
  
        if (response[0].status == 0 && response[1].status == 0) {
          const activatedTaskData = response[0].processList;
          const usersData = response[1].result;
  
          const activatedtasksData = [];
  
          _.forEach(activatedTaskData, function (activatedTask) {
            const assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0]) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" });
  
            const responsibleUser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleUser[0]) ? (responsibleUser[0].FirstName + " " + responsibleUser[0].LastName) : "" });
  
            activatedtasksData.push(activatedTask);
          });
  
          this.companytasklist = activatedtasksData;
  
          // 🚨 Delay triggering until AFTER Angular has updated the DOM
          setTimeout(() => {
            this.dtTrigger.next();
            // Position completion button next to DataTables buttons
            this.positionCompletionButton();
          }, 0);
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });
  }
  

  initiateUploadProof() {
    var filteredTaskList = _.filter(this.companytasklist, function (element) {
      return element.SelectedTask == true
    })
    if (filteredTaskList.length > 1) {
      this.alert.success('Proof can be uploaded for only one task at a time')
    } else if (filteredTaskList.length == 0) {
      this.alert.error('Please select one task to upload proof')
    } else {
      this.taskId = filteredTaskList[0]._id;
      this.getTaskProofFiles();
      $("#uploadProofDialogTitle").html("Task Proof");
      $("#uploadProofDialog1").modal('toggle');
    }
  }

  proofChangeEvent(fileInput: any) {
    this.typeHasError = false
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.typeHasError = false;
    } else {
      this.typeHasError = true;
    }
  }

  uploadProofFile() {
    var file = this.filesToUpload;
    var self = this;
    var pdfData = [];
    this.insertFileIndividuallyInDocumentForPdf('Task Proof', file, 'Attachment').then(function (response) {

      console.log(response);
      if (response.status == 0) {
        for (var i = 0; i < response.result.length; i++) {
          var data = {
            IsAvailable: true,
            TaskId: self.taskId,
            DocumentManagementID: response.result[i].Document._id,
            UploadDate: new Date(),
            IsPublished: true,
            DocName: response.result[i].Document.OriginalFileName,
            UploadFileName: response.result[i].Document.Filename,
          }
          pdfData.push(data);
        }
        self.taskService.uploadTaskProof(pdfData).subscribe(responseData => {
          self.alert.success("Proof File Uploaded Successfully");
          self.getTaskProofFiles()
          self.filesToUpload = undefined;
          $(".fileUpload").val("");
        })
      } else {
        self.alert.error(response.message);
      }
    }, (error) => {
      this.alert.error(error);
    })
  }

  insertFileIndividuallyInDocumentForPdf(fileFor, file, type): Promise<any> {
    return this.makeFileRequest2(environment.pssServerUrl + "documentManagement/taskProofFileUpload/", [], file, fileFor, type).then((result) => {
      console.log(result);
      if (result) {
        return this.documentManagementService.addMultiplePdfDocuments(result)
          .toPromise().then(res => { return Promise.resolve(res); })
        // documentManagement/--Post
      }
    })
  }

  makeFileRequest2(url: string, params: Array<string>, files: Array<File>, fileFor, type) {
    var pdfArray = [];
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = name;

        var documentManagement = {
          "DocumentManagement": {
            DocumentName: this.titleOnAddUpdate + '- Documents-' + Date.now() + fileFor + ' ' + type + ' - ' + this.FileOrignalName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }

        pdfArray.push(documentManagement);
        this.pdfArray1.push(documentManagement);
        console.log(this.pdfArray1);

      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(pdfArray);
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  getTaskProofFiles() {
    this.taskService.getTaskProofFiles(this.taskId)
      .subscribe(taskProofResponse => {
        if (taskProofResponse.status == 0) {
          $("#groupTable").DataTable().destroy();
          this.taskProofData = []
          this.taskProofData = taskProofResponse.data.TaskProof;
          this.dtTrigger.next();
          setTimeout(() => {
            $("#groupTable").DataTable().columns.adjust().draw();
          }, 200);
        }
      })
  }

  downloadDoc(downloadDocumentID) {
    this.taskService.downloadTaskProof(downloadDocumentID)
  }

  deleteProofDoc(pdfId, documentId) {
    $("#deletePdfConfirmation").modal('toggle');
    this.pdfToDelete = pdfId;
    this.documentIdToDelete = documentId
  }
  back() {
    // var fromMeeting = localStorage.getItem('fromMeeting')
    // this.router.navigate(['/meeting']);
    this.ngOnInit();
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['activatedprocess']  } }],
      { relativeTo: this.route.parent });
    // this.location.back(); 
  }
  removeDoc() {
    this.taskService.removeTaskProof(this.taskId, this.documentIdToDelete, this.pdfToDelete).subscribe(responseData => {
      if (responseData) {
        this.getTaskProofFiles();
      }
    });
  }

}
